
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWarningTransferredIec as ObiWarningTransferredIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-warning-transferred-iec.js';
 
 
 

 
 export const ObiWarningTransferredIec = createComponent({
   react: React,
   tagName: 'obi-warning-transferred-iec',
   elementClass: ObiWarningTransferredIecElement,
   events: {
     
   }
  });
 
 